import { getMarketingCardEndpoint } from 'cpfr-common';
import { createCmsContentSlice } from 'cms-integration';
import { MarketingCard } from './utils';

const { reducer, fetchContent } = createCmsContentSlice<MarketingCard>({
    contentName: 'marketingCard',
    contentEndpoint: getMarketingCardEndpoint,
});

export default reducer;
export const fetchMarketingCard = fetchContent;
